// extracted by mini-css-extract-plugin
module.exports = {"root":"authAdminForm_root__Yme4h","logo":"authAdminForm_logo__3TfEf","forgot":"authAdminForm_forgot__2-ePQ"};